<template>
  <div class="payments-header">
    <el-row :gutter="10">
      <el-col
        :span="24"
        class="invoice-header">
        <p class="payment-due-info text-left">
          <span class="invoice-title">Invoices</span>
        </p>
        <div
          class="btn-group pull-right"
          role="group"
          v-if="getPurchaseOrder.payment.proForma">
          <a
            class="btn btn-default"
            :href="getPurchaseOrder.payment.proForma"
            :download="getPurchaseOrder.payment.proForma">
            Download pro forma
          </a>
          <button
            class="pull-right btn-default btn"
            v-if="getPurchaseOrder.payment.proForma && (checkUserGroup(getGroups.FACTORY) || checkUserGroup(getGroups.MANAGE))"
            @click="addProFormaDialog = true">
            Edit
          </button>
        </div>
        <el-button
          class="pull-right"
          v-if="!getPurchaseOrder.payment.proForma && (checkUserGroup(getGroups.FACTORY) || checkUserGroup(getGroups.MANAGE))"
          icon="upload2"
          @click="addProFormaDialog = true">
          Add pro forma
        </el-button>
        <span v-if="(!checkUserGroup(getGroups.FACTORY) && !checkUserGroup(getGroups.MANAGE)) && !getPurchaseOrder.payment.proForma">
          <strong>No pro forma added yet.</strong>
        </span>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <div class="flex">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getPurchaseOrder.payment.observation"
            placement="bottom">
            <p
              v-if="getPurchaseOrder.payment.observation != ''"
              class="payment-obs"><strong>Payment obs: </strong></p>
          </el-tooltip>
          <p
            class="payment-due-info"
            v-if="getPurchaseOrder.payment.status != 'paid'">
            <strong>Total: </strong>{{ item.payment.amount | currency }}
          </p>
          <p
            class="payment-due-info"
            v-else><el-tag type="success">Paid</el-tag></p>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <p
          v-if="getPurchaseOrder.payment.observation != ''"
          class="payment-obs">{{ getPurchaseOrder.payment.observation }}</p>
      </el-col>
    </el-row>
    <el-dialog
      title="Add/Edit pro forma file"
      :visible.sync="addProFormaDialog" >
      <el-upload
        class="upload-demo"
        drag
        ref="uploadProForma"
        :headers="getHeaders"
        :action="getUploadProFormaUrl"
        :on-error="onUploadError"
        :on-success="onUploadSucces"
        :before-upload="setIsFileUpload"
        :auto-upload="true">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
      </el-upload>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          type="primary"
          :plain="true"
          :disabled="isFileUpload"
          @click="addProFormaDialog = false;">Close</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as groups from '@/js/user-groups';
import apiUrl from '@/services/api_url';
import { mapGetters } from 'vuex';
import getFileUploadHeaders from '@/services/http-file-headers';

export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      addProFormaDialog: false,
      isFileUpload: false,
    };
  },
  computed: {
    getPurchaseOrder() {
      return this.$store.getters.getPOItem;
    },
    ...mapGetters({
      getUser: 'getUser',
    }),
    getGroups() {
      return groups;
    },
    getHeaders() {
      return getFileUploadHeaders();
    },
    getUploadProFormaUrl() {
      return `${apiUrl}pos/${this.item.id}/sendProForma/`;
    },
  },
  methods: {
    setIsFileUpload() {
      this.isFileUpload = true;
    },
    onUploadSucces(response) {
      this.$message.success('Success! File uploaded.');
      this.isFileUpload = false;
      this.addProFormaDialog = false;
      this.$store.dispatch('setNewPoItem', response);
      this.$refs.uploadProForma.clearFiles();
    },
    onUploadError() {
      this.$message.error('Oops! Something went wrong.');
      this.isFileUpload = false;
    },
    checkUserGroup(group) {
      if (process.env.NODE_ENV === 'production') {
        for (let i = 0; i < this.getUser.groups.length; i += 1) {
          if (this.getUser.groups[i].name.toLowerCase() === group.toLowerCase()) {
            return true;
          }
        }
      }
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
.invoice-title {
  line-height:1;
  font-size: 1.9em;
  text-transform: capitalize;
}
.payment-due-info, .payment-obs{
    font-size: 1.4em;
    text-transform: uppercase;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    .el-tag {
      height: 40px;
      padding: 0 20px;
      line-height: 40px;
      font-size: 1em;
    }

}
.payment-due-date {
  max-width: 400px;
  margin: 35px auto;
  .el-button {
    width: 100%;
  }
}
.empty-title {
  margin: 50px 0;
}
.invoice-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  h1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      margin-right: 10px;
    }
  }
}
.payment-obs {
    overflow: hidden;
    display: inline-block;
    white-space: pre-wrap;
}
.payments-header {
  .flex {
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/purchase-orders/purchase-order/partials/payment-partials/PoPaymentsHeader.vue